import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Home.css';
import phoenix from '../assets/phoenix.jpeg';
const Home = () => {
  return (
    <section className="home">
      <div className="hero"
       style={{ backgroundImage: `url(${phoenix})` }}>
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1>Welcome to Infinix Academy</h1>
          <p>
            Just like the phoenix rises from its ashes, our students are set to soar and achieve greatness.
            Discover your future with expert guidance and innovative resources.
          </p>
          <Link to="/signup" className="btn">Join Us Now</Link>
        </div>
      </div>
      <div className="features">
        <div className="feature">
          <h2>Transformative Guidance</h2>
          <p>Empowering you to overcome challenges and unlock your true potential.</p>
        </div>
        <div className="feature">
          <h2>Innovative Learning</h2>
          <p>Access cutting-edge resources and insights to fuel your academic journey.</p>
        </div>
        <div className="feature">
          <h2>Success Stories</h2>
          <p>Join a community of achievers who have transformed their futures.</p>
        </div>
      </div>
    </section>
  );
};

export default Home;
